<template>

  <div class="item_main">

    <div class="title">1.进入拼词</div>
    <div class="content">点击弹窗中的拼词模式，进入拼词页面。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/enterspell.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">2.开启</div>
    <div class="content">点击底部中间播放按钮，即可开启拼词模式。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/spell.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">3.设置</div>
    <div class="content">点击拼词页面右下角的设置按钮，弹出设置弹窗，可设置排序、播放、音效及是否使用键盘等参数。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/spellsetup.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">4.筛选</div>
    <div class="content">点击拼词页面左下角的筛选按钮，可选择需要拼词的单词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/spellfilter.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">5.拼词方法</div>
    <div class="content">可使用键盘输入，也可以不选中设置中的“使用键盘”选项，使用按钮输入。
  
    </div>
    <div class="second_title">使用键盘</div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/usekeyboard.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="second_title">使用按钮</div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/usebutton.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">6.加入生词</div>
    <div class="content">点击拼词页面加入生词按钮，可加入生词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/addnew.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">7.加入熟知</div>
    <div class="content">点击拼词页面加入熟知按钮，可加入熟知词。
  
    </div>


    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/addknown.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    
   





    </div>
  

  
 



  
  

  
    
  </template>
  
  <script setup>

  </script>
  
  <style scoped>

  .item_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  .title {
    font-size: 0.45rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .second_title {
    font-size: 0.42rem;
    
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .content {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  </style>